// Typical Singapore market prices for common electrician and handyman jobs,
// shown next to StringsSG's own price on the two price-list pages.
//
// How these were collected: published "from" prices (labour only) on the price
// pages of Singapore electrician and handyman companies that rank on page one
// for "electrician singapore" and "handyman singapore". A row is included only
// when at least two providers publish a price for a comparable job. Providers
// are not named on the page, because their prices change without notice.
//
// Re-verify these before changing `verifiedOn`. Do not edit a range without
// re-checking the sources.
//
// `ourItems` are exact itemName values from GetHandymanPriceList. The page shows
// the lowest live StringsSG price among them, so that column never goes stale.
// It is shown even where StringsSG is dearer (TV bracket), so the comparison is honest.

export const handymanMarketRatesVerifiedOn = '2026-09-23'

export const electricianMarketRates = [
    { job: 'Replace light bulb or fitting', low: 40, high: 120, ourItems: ['Replace light bulb'] },
    { job: 'Install LED light or downlight', low: 55, high: 105, ourItems: ['Install/replace LED light', 'Install / replace downlight'] },
    { job: 'Replace power socket or switch', low: 40, high: 150, ourItems: ['Replace power socket or switch'] },
    { job: 'Install ceiling fan', low: 60, high: 250, ourItems: ['Install ceiling fan'] },
    { job: 'Aircon or water heater power point', low: 45, high: 200, ourItems: ['Supply and install 15AMP aircon point (non-conceal)', 'Supply and install 20AMP water heater point (non-conceal)'] },
    { job: 'Install instant water heater', low: 60, high: 250, ourItems: ['Replace instant water heater'] },
    { job: 'New distribution board (DB box)', low: 360, high: 1200, ourItems: ['Install electrical distribution board (DB box)'] },
]

export const handymanMarketRates = [
    { job: 'Install curtain rod or track', low: 80, high: 150, ourItems: ['Installing Curtain Rods', 'Installing Curtain Blinds/Track'] },
    { job: 'Mount TV bracket (labour only)', low: 70, high: 130, ourItems: ['Install TV bracket for wall mount'] },
    { job: 'Assemble furniture (per item)', low: 40, high: 200, ourItems: ['Fix/install bedframe'] },
    { job: 'Replace light bulb or fitting', low: 40, high: 120, ourItems: ['Replace light bulb'] },
    { job: 'Replace power socket or switch', low: 40, high: 150, ourItems: ['Replace power socket or switch'] },
    { job: 'Install ceiling fan', low: 60, high: 250, ourItems: ['Install ceiling fan'] },
    { job: 'Install instant water heater', low: 60, high: 250, ourItems: ['Replace instant water heater'] },
]

// Several providers add a transport or call-out fee of up to $50 on top of the
// listed price. That is shown as a general tip, not as a claim about StringsSG.
export const marketCallOutFeeMax = 50
